// test523
(523 && 0);
